/**
 * Todas as permissões devem estar no enum principal para serem carregadas na inicialização
 */
export enum PermissionResourcesCareer {
	RISK_TEAM_LOSS = "res://senior.com.br/analytics/hcm/career/manager/workstationRiskSummary",
	TEAM_CAREER_PLAN = "res://senior.com.br/analytics/hcm/career/manager/careerAndSuccession",
	WORKSTATION_KEY_POSITION_SUMMARY = "res://senior.com.br/analytics/hcm/career/manager/workstationKeyPositionSummary",
	EMPLOYEE_CAREER_PLAN = "res://senior.com.br/analytics/hcm/career/employee/employeeCareerPlan",
	VACANCY_PER_RESPONSIBLE = "res://senior.com.br/hcm/recruitment/vacancyPerResponsiblePortlet",
	OPEN_VACANCIES = "res://senior.com.br/hcm/recruitment/openVacanciesPortlet",
	READINESS_LEVEL = "res://senior.com.br/analytics/hcm/career/manager/readinessLevelSummary",
	LED_KEY_POSITION = "res://senior.com.br/analytics/hcm/career/manager/workstationKeyPosition",
	EMPLOYEE_SUCESSION_PLAN = "res://senior.com.br/analytics/hcm/career/employee/successionPlan",
	MY_SUCCESSION_PLAN_DETAIL = "res://senior.com.br/analytics/hcm/career/employee/mySuccessionPlanDetail",
	CAREER_PLAN = "res://senior.com.br/analytics/hcm/career/employee/myCareerPlan",
	VIEW_VACANCY = "res://senior.com.br/hcm/vacancymanagement/entities/vacancy",
}

/**
 * Cards da página Manager, aba career
 */
export enum PermissionResourcesCareerManager {
	TEAM_CAREER_PLAN = "res://senior.com.br/analytics/hcm/career/manager/careerAndSuccession",
	WORKSTATION_KEY_POSITION_SUMMARY = "res://senior.com.br/analytics/hcm/career/manager/workstationKeyPositionSummary",
	RISK_TEAM_LOSS = "res://senior.com.br/analytics/hcm/career/manager/workstationRiskSummary",
	READINESS_LEVEL = "res://senior.com.br/analytics/hcm/career/manager/readinessLevelSummary",
}

/**
 * Cards da página My, aba career
 */
export enum PermissionResourcesCareerMy {
	EMPLOYEE_SUCESSION_PLAN = "res://senior.com.br/analytics/hcm/career/employee/successionPlan",
	CAREER_PLAN = "res://senior.com.br/analytics/hcm/career/employee/myCareerPlan",
	VIEW_VACANCY = "res://senior.com.br/hcm/vacancymanagement/entities/vacancy"
}

/**
 * Cards da página Led, aba career
 */
export enum PermissionResourcesCareerLed {
	LED_KEY_POSITION = "res://senior.com.br/analytics/hcm/career/manager/workstationKeyPosition",
	EMPLOYEE_CAREER_PLAN = "res://senior.com.br/analytics/hcm/career/employee/employeeCareerPlan"
}
